import React from 'react';
import StickyFooter from '@framework/ui/Organisms/StickyFooter';

interface IProps {
  config: any,
  contentClassName: string,
}

const Footer = (props: IProps) => (
  <StickyFooter
    contentClassName={ props.contentClassName }
    config={ props.config }
  />
);

export default Footer;
